import { render, staticRenderFns } from "./ProductCategorySorter.vue?vue&type=template&id=1bb3f00e&scoped=true&"
import script from "./ProductCategorySorter.vue?vue&type=script&lang=js&"
export * from "./ProductCategorySorter.vue?vue&type=script&lang=js&"
import style0 from "./ProductCategorySorter.vue?vue&type=style&index=0&id=1bb3f00e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb3f00e",
  null
  
)

export default component.exports